import useBootstrapData from '@/hooks/useBootstrapData'
import useHandleAppDownloadSubmit from '@/hooks/useHandleAppDownloadSubmit'
import { ActionCard } from '@pcln/cards'
import { OptInCard } from '@pcln/marketing'
import { Box, Flex } from 'pcln-design-system'
import { Bag, Help } from 'pcln-icons'
import { CONTENT, trackHelpCenter, trackMyTrips } from './utils'

export default function AppDownloadOptIn() {
  const [handleSubmitNumber, signUpState] = useHandleAppDownloadSubmit()
  const { signInStatus } = useBootstrapData()
  return (
    <Flex>
      <Box mr={3}>
        <OptInCard
          {...CONTENT}
          desktopImageAlignment='right'
          signUpState={signUpState}
          handleFormSubmit={handleSubmitNumber}
        />
      </Box>
      <Flex flexDirection='column' style={{ gap: 16 }}>
        <ActionCard
          headingWidth='300px'
          icon={<Bag color='primary' />}
          heading='My Trips'
          caption='Quickly find your booking reservations and redeem flight credits'
          isIconRounded={false}
          onClick={() => trackMyTrips(signInStatus.signedIn)}
          handleSubmitCTA={() => trackMyTrips(signInStatus.signedIn)}
        />
        <ActionCard
          headingWidth='300px'
          icon={<Help />}
          heading='Help Center'
          isIconRounded={false}
          caption='We are always Here for you - reach us 24hrs a day, 7 days a week'
          onClick={trackHelpCenter}
          handleSubmitCTA={trackHelpCenter}
        />
      </Flex>
    </Flex>
  )
}
